
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hardware/mediumTerminal",
      function () {
        return require("private-next-pages/hardware/mediumTerminal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hardware/mediumTerminal"])
      });
    }
  